"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var constants_1 = require("./constants");
var generateControlTreatment_1 = __importDefault(require("./generateControlTreatment"));
var isClientSide_1 = __importDefault(require("./isClientSide"));
var getClientSideSplitTreatments = function (treatmentNames, splitKey, _a) {
    var _b = _a === void 0 ? {} : _a, attributes = _b.attributes, _c = _b.apiPathString, apiPathString = _c === void 0 ? constants_1.DEFAULT_GET_TREATMENTS_ROUTE : _c;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, _d, _e, _f, e_1;
        var _g, _h;
        var _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    _l.trys.push([0, 3, , 4]);
                    if (!(0, isClientSide_1.default)()) {
                        throw new Error("Cannot use getClientSideSplitTreatments server-side. Use getServerSideSplitTreatments instead.");
                    }
                    _e = (_d = axios_1.default).get;
                    _f = [apiPathString];
                    _g = {};
                    _h = {
                        attributes: attributes
                    };
                    return [4 /*yield*/, splitKey];
                case 1: return [4 /*yield*/, _e.apply(_d, _f.concat([(_g.params = (_h.splitKey = _l.sent(),
                            _h.treatmentNames = String(treatmentNames),
                            _h),
                            _g)]))];
                case 2:
                    data = (_l.sent()).data;
                    return [2 /*return*/, data];
                case 3:
                    e_1 = _l.sent();
                    console.error(new Error(axios_1.default.isAxiosError(e_1)
                        ? ((_k = (_j = e_1.response) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.error) || constants_1.GENERIC_TREATMENTS_ERROR
                        : (typeof e_1 === "object" && e_1.message) || constants_1.GENERIC_TREATMENTS_ERROR));
                    return [2 /*return*/, (0, generateControlTreatment_1.default)(treatmentNames)];
                case 4: return [2 /*return*/];
            }
        });
    });
};
exports.default = getClientSideSplitTreatments;
